import { render, staticRenderFns } from "./InvoicePaymentReceived.vue?vue&type=template&id=54435d23&scoped=true"
import script from "./InvoicePaymentReceived.vue?vue&type=script&lang=js"
export * from "./InvoicePaymentReceived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54435d23",
  null
  
)

export default component.exports